<template>
  <div class="yearList">
    <div class="yearBanner">
      <div class="config">
        <router-link to="/" class="logo" target="_blank"
          ><img src="/static/year/Landingpage_MANA_head_logo@2x.png" alt=""
        /></router-link>

        <el-popover placement="bottom" width="240px" trigger="hover">
          <share :config="config"></share>
          <span class="configBox" slot="reference">
            <img src="/static/year/landingpage_share_icon@2x.png" alt="" /><span
              class="text"
              >{{ $t("global.分享") }}</span
            >
          </span>
        </el-popover>
      </div>
    </div>
    <div class="imgList">
      <div
        class="imgBox"
        v-for="(item, i) in imgList"
        :key="i"
        :style="{ backgroundImage: `url(${item.imgurl})` }"
        @mouseenter="index = i"
        @mouseleave="index = null"
        @click="goto(item.url)"
      >
        <div class="butBox" :class="{ active: index == i }">
          <img
            src="https://image.manamana.net/1672897938000_pphLkyTy"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Share from "@/components/v2/Share";
export default {
  name: "flowingLight",
  metaInfo() {
    return {
      title: "2022中国·重庆首届国际光影艺术节 | MANA",
    };
  },
  data() {
    return {
      config: {},
      index: null,
      imgList: [
        {
          imgurl: "https://image.manamana.net/1672809168000_GoGvGPvg",
          url: "/video/detail?id=2102425",
        },
        {
          imgurl: "https://image.manamana.net/1672809193000_hZFTMRoc",
          url: "/video/detail?id=2102880",
        },
        {
          imgurl: "https://image.manamana.net/1672809297000_UdqqzzpM",
          url: "/video/detail?id=2103227",
        },
        {
          imgurl: "https://image.manamana.net/1672809336000_sLHMOhaI",
          url: "/video/detail?id=2102982",
        },
        {
          imgurl: "https://image.manamana.net/1672809181000_kaDATXzY",
          url: "/video/detail?id=2102521",
        },
        {
          imgurl: "https://image.manamana.net/1672809264000_ZDBsQundefinedpx",
          url: "/video/detail?id=2102322",
        },
        {
          imgurl: "https://image.manamana.net/1672809250000_CwUvZMwG",
          url: "/video/detail?id=2102197",
        },
        {
          imgurl: "https://image.manamana.net/1672809375000_IdfEoaxq",
          url: "/video/detail?id=2103054",
        },
        {
          imgurl: "https://image.manamana.net/1672809280000_GNUFiCgq",
          url: "/video/detail?id=2103133",
        },
        
        {
          imgurl: "https://image.manamana.net/1672809310000_piHaaBub",
          url: "/video/detail?id=2102730",
        },
        {
          imgurl: "https://image.manamana.net/1672809323000_gwHeKfym",
          url: "/video/detail?id=2103279",
        },
        {
          imgurl: "https://image.manamana.net/1672809351000_QmwoRgpi",
          url: "/video/detail?id=2103246",
        },
        {
          imgurl: "https://image.manamana.net/1672809363000_rFMdapMr",
          url: "/video/detail?id=2102415",
        },
        {
          imgurl: "https://image.manamana.net/1672809391000_NIzSgyGL",
          url: "/video/detail?id=2103449",
        },
        {
          imgurl: "https://image.manamana.net/1672809403000_zRfhMlaG",
          url: "/video/detail?id=2101653",
        },
        {
          imgurl: "https://image.manamana.net/1672809418000_vGPBUvEG",
          url: "/video/detail?id=2102962",
        },
        {
          imgurl: "https://image.manamana.net/1672809433000_DLUDAPYE",
          url: "/video/detail?id=2101401",
        },
        {
          imgurl: "https://image.manamana.net/1672809448000_nnvYQHgE",
          url: "/video/detail?id=2102799",
        },
        {
          imgurl: "https://image.manamana.net/1672809467000_PZCgECfV",
          url: "/video/detail?id=2102783",
        },
        {
          imgurl: "https://image.manamana.net/1672809480000_YsoUCshD",
          url: "/video/detail?id=2101645",
        },
        {
          imgurl: "https://image.manamana.net/1672809494000_VrMzHDGq",
          url: "/video/detail?id=2101425",
        },
        {
          imgurl: "https://image.manamana.net/1672809512000_hurLcvwt",
          url: "/video/detail?id=2101155",
        },
        {
          imgurl: "https://image.manamana.net/1672809528000_XWqFPlpk",
          url: "/video/detail?id=2101701",
        },
        {
          imgurl: "https://image.manamana.net/1672809545000_LCIVSWXK",
          url: "/video/detail?id=2101521",
        },
        {
          imgurl: "https://image.manamana.net/1672809900000_bwhvPibQ",
          url: "/video/detail?id=2101624",
        },
        {
          imgurl: "https://image.manamana.net/1672809917000_TMzhXQxG",
          url: "/video/detail?id=2101429",
        },
        {
          imgurl: "https://image.manamana.net/1672809929000_OZgKsRundefinedS",
          url: "/video/detail?id=2101222",
        },
        {
          imgurl: "https://image.manamana.net/1672809945000_ixVzbEQt",
          url: "/video/detail?id=2103355",
        },
        {
          imgurl: "https://image.manamana.net/1672809957000_GBsVyLXO",
          url: "/video/detail?id=2101381",
        },
        {
          imgurl: "https://image.manamana.net/1672809972000_HHNyiXvg",
          url: "/video/detail?id=2103481",
        },
        {
          imgurl: "https://image.manamana.net/1673315554000_LGFsRmoN",
          url: "/video/detail?id=2102003",
        },
        {
          imgurl: "https://image.manamana.net/1672809998000_oMMZUtHg",
          url: "/video/detail?id=2101311",
        },
        {
          imgurl: "https://image.manamana.net/1672810010000_NovosLqo",
          url: "/video/detail?id=2101469",
        },
        {
          imgurl: "https://image.manamana.net/1672810022000_fQrlCcAW",
          url: "/video/detail?id=2101520",
        },
        {
          imgurl: "https://image.manamana.net/1672810036000_uhgrbrPG",
          url: "/video/detail?id=2102092",
        },
        {
          imgurl: "https://image.manamana.net/1672810046000_kBFvueZC",
          url: "/video/detail?id=2101740",
        },
        {
          imgurl: "https://image.manamana.net/1672810059000_nAllIKZG",
          url: "/video/detail?id=2101238",
        },
        {
          imgurl: "https://image.manamana.net/1672810071000_VHHYEMpZ",
          url: "/video/detail?id=2101904",
        },
        {
          imgurl: "https://image.manamana.net/1672810082000_QeQGyySL",
          url: "/video/detail?id=2102188",
        },
        {
          imgurl: "https://image.manamana.net/1672810093000_pQyZeRxa",
          url: "/video/detail?id=2101905",
        },
      ],
    };
  },
  created() {
    this.config = {
      share_url: location.href,
      title: '2022中国·重庆首届国际光影艺术节入围奖作品合辑',
      desc: "艺术让生活更美好",
      pics: "https://image.manamana.net/1672802500000_kUrXlBEw",
    };
  },
  components: {
    Share,
  },
  methods: {
    goto(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
<style lang="stylus" scoped>
.yearList {
  background: url('https://image.manamana.net/1641535210000_gNSARNfQ');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  min-width: 918px;
  min-height: 100vh;
  .yearBanner {
    background: url('https://image.manamana.net/1672810289000_ZkbGxFLo');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    background-position-x: center;
    height: 350px;

    .config {
      padding: 10px 30px 0;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .logo {
        display: inline-block;
        width: 120px;
        height: 50px;
        vertical-align: middle;
        margin-right: 28px;
        cursor: pointer;

        img {
          width: 120px;
          height: 50px;
        }
      }

      .configBox {
        display: inline-block;
        vertical-align: middle;
        height: 40px;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 40px;
        cursor: pointer;

        img {
          width: 40px;
          height: 40px;
        }

        .text {
          vertical-align: middle;
          margin-left: 4px;
        }
      }
    }
  }

  .imgList {
    width: 918px;
    margin: 0 auto;
    padding: 40px 0 120px 0;

    .imgBox {
      width: 100%;
      height: 194px;
      margin-bottom: 40px;
      background-size: 100%;
      position: relative;
      cursor: pointer;
      .butBox {
        height: 194px;
        width: 100%;
        line-height: 194px;
        text-align: center;
        img {
          display: none;
        }
      }

      .active {
        color: #FFFFFF;
        background: rgba(0, 0, 0, 0.5);
        img {
          display: inline-block;
          width: 44x;
          height: 44px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/yearList/CQILAC2022.vue